import { createSelector } from 'reselect';

import { getState } from '../rootSelector';

export const getShowSuggestionModal = createSelector(getState, state => state.showSuggestionModal);
